import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AcaoListComponent } from './acao-list/acao-list.component';
import { AcaoFormComponent } from './acao-form/acao-form.component';
import { AuthGuard } from 'eddydata-lib';

const routes: Routes = [
  { path: '', component: AcaoListComponent, canActivate: [AuthGuard] },
  { path: 'novo', component: AcaoFormComponent, canActivate: [AuthGuard] },
  { path: ':id/editar', component: AcaoFormComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AcaoRoutingModule { }
